
  import { css } from 'lit';
  export const styles = css`[part=base]{background:var(--background)}`;
  